import { createContext } from "react";

const ReceiverContext = createContext();

export default ReceiverContext;
